<template>
	<div>
		<div class="flex xs-12 xs-middle mb2" v-for="(item, index) in value" :key="index">
			<!-- Type Input -->
			<j-base-input-text
				class="xs-5"
				:value="item.type"
				@input="onInput(index, 'type')"
				@blur="onBlur(index, 'type')"
				v-model="item.type"
				:status="objectErrors[index]['type'] ? 'error' : null"
				:placeholder="$t('type')"
			/>
			<!-- Value Input -->
			<j-base-input-text
				class="xs-5 ml2"
				:value="item.value"
				@input="onInput(index, 'value')"
				@blur="onBlur(index, 'value')"
				v-model="item.value"
				:status="objectErrors[index]['value'] ? 'error' : null"
				:placeholder="$t('value')"
			/>
			<!-- Remove Button -->
			<j-button class="ml3" type="error" size="xsmall" @click="removeFromList(index)">{{ $t("remove") }}</j-button>
		</div>
		<p class="fs3 cError fw4" v-if="checkForDuplicateKeys">{{$t("duplicate_type")}}</p>
		<div class="flex xs-12 xs-right">
			<!-- Add Button -->
			<j-button type="secondary" @click="addToList" size="xsmall">{{ $t("add_row") }}</j-button>
		</div>
	</div>
</template>

<script>
import JBaseInputText from "@/components/JBaseInputText/"
import CrmIcon from "@/components/CrmIcon/"
import JButton from "@/components/JButton/"
import get from "lodash.get"

export default {
	name: "j-input-object-list",

	props: {
		value: {
			default: () => [{ type: null, value: null }]
		}
	},

	data() {
		return {
			objectErrors: [{ type: false, value: false }]
		}
	},

	components: {
		JBaseInputText,
		CrmIcon,
		JButton
	},

	methods: {
		//Add new object to Array
		addToList() {
			this.value.push({ type: null, value: null })
			this.objectErrors.push({ type: false, value: false })
		},

		//Remove selected object from Array
		removeFromList(index) {
			if (this.value.length > 1) {
				this.value.splice(index, 1)
				this.objectErrors.splice(index, 1)
			} else {
				this.value = [{ type: null, value: null }]
				this.objectErrors = [{ type: null, value: null }]
			}
		},

		setObjectErrors(index, field) {
			this.objectErrors[index][field] = !this.value[index][field]
				? true
				: false
		},

		onInput(index, field) {
			this.setObjectErrors(index, field)
			this.$emit("input", this.value)
		},

		onBlur(index, field) {
			this.setObjectErrors(index, field)
		}
	},

	computed: {
		checkForDuplicateKeys() {
			let array = this.value.map(item => item.type)
			return array.some(item => {
				return array.indexOf(item) !== array.lastIndexOf(item)
			})
		}
	},

	created() {
		this.objectErrors = this.value.map(item => {
			return {
				type: false,
				value: false
			}
		})
	}
}
</script>
